<template>
    <asli-popup :show-close-button="true" v-model="displayModal" class="p-4">
        <div class="px-8 py-4">
            <asli-section-header class="my-[15px]">Update Quote</asli-section-header>
            <p class="text-sm mb-[15px]">
                Your start date for this quote is no longer valid, please update below when you would like this policy
                to start.
            </p>
            <asli-form @submitted="updateQuote" class="w-full mx-auto">
                <asli-date
                    id="policy_start_date_inv"
                    name="policy_start_date_inv"
                    rules="required"
                    label="When do you require cover from i.e. policy/cover start date?"
                    :date-from="startDateFrom"
                    :date-to="startDateTo"
                    :show-today="false"
                    v-model="policyDetails.start_date"
                    :is-calendar-centered="true"
                    calendar-aria-label="Open calendar to select policy start date"
                />
                <button-bar class="flex-col sm:flex-row">
                    <asli-button id="form-back" color="secondary" type="button" @click="closeModal">Back</asli-button>
                    <asli-button id="form-continue" color="primary" type="submit">Confirm</asli-button>
                </button-bar>
            </asli-form>
        </div>
    </asli-popup>
</template>

<script lang="ts" setup>
import { useMainStore } from "@/stores/main";
import { useProposalStore } from "@/stores/risk/risk";
import { AsliPopup, AsliButton, AsliForm, AsliDate, AsliSectionHeader } from "@mbs-npm/anpost-ui";
import { computed, ref } from "vue";
import dayjs from "dayjs";
import { PolicyDetails } from "@/stores/risk/types/types";
import ButtonBar from "@/components/ButtonBar.vue";
import router from "@/router";
import { ROUTE_NAMES } from "@/router/types";

const mainStore = useMainStore();
const proposalStore = useProposalStore();
import { GA4Helper } from "@/utils/ga4-dataLayers";

const displayModal = computed({
    get: () => mainStore.displayStartDateIsInvalidModal,
    set: val => (mainStore.displayStartDateIsInvalidModal = val)
});

const policyDetails = ref<PolicyDetails>({
    start_date: proposalStore.proposal.risk.policy_details?.start_date,
    property_type: proposalStore.proposal.risk.policy_details?.property_type
});

const startDateFrom = new Date();
const startDateFromDay = dayjs(startDateFrom);
const startDateTo = computed(() => startDateFromDay.add(30, "day").toDate());

async function updateQuote() {
    proposalStore.patchPolicyDetails(policyDetails.value);
    displayModal.value = false;
    mainStore.setLoadingState(true);
    await proposalStore.updateProposal();
    await proposalStore.createQuote();
    GA4Helper.trackVirtualPageView("/quote/update-start-date", "Update Quote Start Date");
    router.push({
        name: ROUTE_NAMES.YourQuotes,
        query: {
            uuid: proposalStore.proposal.uuid
        }
    });
    mainStore.setLoadingState(false);
}

function closeModal() {
    displayModal.value = false;
}
</script>
